// @ts-nocheck
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const productDetailsFormWrapperStyles = () => {
    return css`
        ${({ theme }) => css`
            ${breakpointValues(theme.design.form.grid.small.vertical, ["margin-top", "margin-bottom"])}
        `}

        /* Greif Custom Code - Start */
        ${breakpoint("sm")} {
            max-width: ${pxToRem(400)};
        }
        /* Greif Custom Code - Start */

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    `;
};
